import { render, staticRenderFns } from "./BulkEditItemList.vue?vue&type=template&id=4fd03067&scoped=true"
import script from "./BulkEditItemList.vue?vue&type=script&lang=js"
export * from "./BulkEditItemList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd03067",
  null
  
)

export default component.exports